'use client';

import { TouchEvent, useRef } from 'react';

type UseHorizontalSwipeParams = {
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  threshold?: number;
};

export const useHorizontalSwipe = ({
  onSwipeLeft,
  onSwipeRight,
  threshold = 35,
}: UseHorizontalSwipeParams) => {
  const touchStartRef = useRef({ x: 0, y: 0 });
  const swipeLockedRef = useRef(false);

  const onTouchStart = (event: TouchEvent<HTMLElement>) => {
    const touch = event.touches[0];
    if (!touch) return;

    touchStartRef.current = {
      x: touch.clientX,
      y: touch.clientY,
    };

    swipeLockedRef.current = false;
  };

  const onTouchMove = (event: TouchEvent<HTMLElement>) => {
    if (swipeLockedRef.current) return;

    const touch = event.touches[0];
    if (!touch) return;

    const dx = touch.clientX - touchStartRef.current.x;
    const dy = touch.clientY - touchStartRef.current.y;

    if (Math.abs(dy) > Math.abs(dx)) return;
    if (Math.abs(dx) < threshold) return;

    swipeLockedRef.current = true;

    if (dx < 0) {
      onSwipeLeft?.();
    } else {
      onSwipeRight?.();
    }
  };

  const onTouchEnd = () => {
    swipeLockedRef.current = false;
  };

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
  };
};
